import React, { useEffect, useState, memo } from "react";
import { connect } from "react-redux";
import app from "../../common/app";
import config from "../../common/config";
import core from "../../common/core";
import Trans from "../../componentsReusable/trans";
import Loader from "../loader";
import {
  fetchBoostersCon,
  fetchGamerCard,
} from "../../redux/actions/appActions";

const UserBoosters = (props) => {
  const propsBack = {
    onClick: () => {
      const { history } = props;
      history && history.goBack();
    },
  };
  const [arrData, setArrData] = useState();
  const [goAhead, setGoAhead] = useState();

  const { arrFixtures, objMix, fetchGamerCard } = props;

  const logoutData = () => {
    const allArrBooster = [];
    for (let x in config.enumBoosterTexts) {
      allArrBooster.push(
        JSON.parse(JSON.stringify(config.enumBoosterTexts[x]))
      );
    }
    const logedOutData = allArrBooster.map((ele) => {
      const { text1, open, className, isActive } = ele;
      return (
        <li>
          <div className={`m11c-booster__box ${className} `}>
            <div className="m11c-booster__icon"></div>
            <div className="m11c-booster__content">
              <div className="m11c-booster__title">
                <span>
                  <Trans sKey={text1} />
                </span>
              </div>
              <div className="m11c-booster__para">
                <span>
                  <Trans sKey={open} />
                </span>
              </div>
            </div>
            <div className="m11c-booster__radioBtn"></div>
          </div>
        </li>
      );
    });
    return logedOutData;
  };

  let cookie = app.getLoginCookie();
  useEffect(() => {
    const { VersionMaster } = objMix || {};
    if (cookie) {
      let payload = {
        guid: cookie.GUID,
        optType: 1,
        platformId: 3,
        clientId: 1,
        VersionMaster: VersionMaster,
      };
      fetchGamerCard &&
        fetchGamerCard(payload).then((resp) => {
          let response = resp?.value?.data?.Data?.Value;
          if (response) {
            setGoAhead(true);
            let allArrBooster = [];
            for (let x in config.enumBoosterTexts) {
              allArrBooster.push(
                JSON.parse(JSON.stringify(config.enumBoosterTexts[x]))
              );
            }
            allArrBooster = allArrBooster.map((ele) => {
              if (response && Object.keys(response).length !== 0) {
                if (response?.[ele?.bsId]) {
                  // console.log(allArrBooster);
                  ele.isActive = true;
                }
              }
              if (ele.isActive) {
                arrFixtures?.map((match) => {
                  if (match?.Gameday === response?.[ele.bsId]) {
                    ele.Gameday = match.Gameday;
                    ele.matches = match;
                  }
                });
              }
              return ele;
            });
            setArrData(allArrBooster);
          }
        });
    }
  }, []);

  const sortedData = arrData?.slice().sort(function (a, b) {
    return a.isActive === b.isActive
      ? b.Gameday - a.Gameday
      : b.isActive
      ? -1
      : 1;
  });
  const showArrBooster = sortedData?.map((ele) => {
    const { text1, open, className, isActive } = ele;

    return (
      <li key={ele.id}>
        <div
          className={`m11c-booster__box ${className} ${
            isActive && "m11c-disabled"
          } m11c-noClick`}
        >
          {/* <!-- m11c-active | m11c-tmp | m11c-dbs | m11c-st | m11c-p-bat | m11c-p-bowl | m11c-p-ar | m11c-p-keeper | m11c-p-uncapped | m11c-p-guest --> */}
          <div className="m11c-booster__icon"></div>
          <div className="m11c-booster__content">
            <div className="m11c-booster__title">
              <span>
                <Trans sKey={text1} />
              </span>
            </div>
            <div className="m11c-booster__para">
              <span>
                <Trans sKey={open} />
              </span>
            </div>
            {
              isActive ? (
                <div className="m11c-booster__status">
                  <span>
                    <Trans sKey={"matchCap"} sValue={"MATCH"} /> {ele?.Gameday}
                  </span>
                  <span>
                    <em>
                      {core.dateFormat(ele?.matches?.Matchdate, "dd mmm yyyy")}
                    </em>
                  </span>
                </div>
              ) : null
              // <div className="m11c-booster__status">
              //   <i className="m11ci-booster-tick"></i>
              //   <span>
              //     {" "}
              //     <Trans sKey={"available"} sValue={"Available"} />
              //   </span>
              // </div>
            }
          </div>
          <div className="m11c-booster__radioBtn"></div>
        </div>
      </li>
    );
  });
  const matchHistory = arrData
    ?.filter((ele) => ele.isActive === true)
    .sort(function (a, b) {
      return b.Gameday - a.Gameday;
    })
    .map((ele, idx) => {
      const { matches, text1, className } = ele;
      const {
        HomeTeamId,
        AwayTeamId,
        HomeTeamCountryCode,
        AwayTeamCountryCode,
        Matchdate,
        Gameday,
      } = matches;

      return (
        <li key={idx}>
          <div className="m11c-homePts__history-fBox">
            <div className="m11c-homePts__history-lft">
              <div className="m11c-homePts__history-matchDtls">
                <span>
                  <Trans sKey={"matchCap"} sValue={"MATCH"} /> {`${Gameday} - `}
                </span>
                <span>{core.dateFormat(Matchdate, "dd mmm yyyy")}</span>
              </div>
              <div className="m11c-fix__team">
                <div className="m11c-fix__team-A">
                  <div
                    className="m11c-fix__team-logo"
                    style={{
                      backgroundImage: `url(${config.IMG_BASE}flags/${AwayTeamId}.png)`,
                    }}
                  ></div>
                  <div className="m11c-fix__team-name">
                    <span>{AwayTeamCountryCode}</span>
                  </div>
                </div>
                <div className="m11c-fix__team-vs">
                  <span>vs</span>
                </div>
                <div className="m11c-fix__team-B">
                  <div className="m11c-fix__team-name">
                    <span>{HomeTeamCountryCode}</span>
                  </div>
                  <div
                    className="m11c-fix__team-logo"
                    style={{
                      backgroundImage: `url(${config.IMG_BASE}flags/${HomeTeamId}.png)`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
            {/* <div className="m11c-homePts__history-rgt">
              <div className="m11c-homePts__history-pts">
            <span>
              <i className="m11ci-lightning"></i> -1
            </span>
          </div>
            </div> */}
            <div className={`m11c-booster__box ${className}`}>
              <div className="m11c-booster__content">
                <div className="m11c-booster__title">
                  <span>
                    <Trans sKey={text1} />
                  </span>
                </div>
              </div>
              <div className="m11c-booster__icon"></div>
            </div>
          </div>
        </li>
      );
    });

  return (
    <div className="m11c-cmo__wrap">
      <div className="m11c-cmo__lhs">
        <div className="m11c-cmo__lhs-head">
          <div className="m11c-cmo__top">
            <div className="m11c-cmo__bck" {...propsBack}>
              <i className="m11ci-back"></i>
            </div>
            <div className="m11c-cmo__status">
              <div className="m11c-cmo__mat-num">
                <span>
                  <Trans sKey={"booster"} sValue={"Booster"} />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="m11c-cmo__lhs-body" style={{ marginTop: "54px" }}>
          <div className="m11c-hp__row">
            {cookie ? (
              goAhead ? (
                <div className="m11c-contest__wrap m11c-contest__wrap--homePts">
                  <div className="m11c-contest__box">
                    <div className="m11c-homePts__header">
                      <div className="m11c-homePts__header-fBox">
                        <div className="m11c-homePts__header-lft">
                          <div className="m11c-homePts__header-icon">
                            <i className="m11ci-lightning"></i>
                          </div>
                          <div className="m11c-homePts__header-text">
                            <span>
                              <em>
                                {arrData?.length - matchHistory?.length}{" "}
                                <span>/ {arrData?.length}</span>
                              </em>
                              <Trans
                                sKey={"boosterAvailable"}
                                sValue={"Booster Available"}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="m11c-contest__box">
                    <div className="m11c-booster__list">
                      <ul>{showArrBooster}</ul>
                    </div>
                  </div>
                  <div className="m11c-contest__box">
                    <div className="m11c-homePts__history">
                      <div className="m11c-homePts__history-title">
                        <Trans
                          sKey={"boosterHistory"}
                          sValue={"Booster History"}
                        />
                      </div>
                      <div className="m11c-homePts__history-list m11c-noClick">
                        {matchHistory && matchHistory.length ? (
                          <ul>{matchHistory}</ul>
                        ) : (
                          <div className="m11c-noDataFound">
                            <div className="m11c-noDataFound__text">
                              <span>
                                <Trans
                                  sKey={"noBoosters"}
                                  sValue={
                                    "See exactly when you used each booster here."
                                  }
                                />
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )
            ) : (
              <div className="m11c-contest__wrap m11c-contest__wrap--homePts">
                <div className="m11c-contest__box">
                  <div className="m11c-homePts__header">
                    <div className="m11c-homePts__header-fBox">
                      <div className="m11c-homePts__header-lft">
                        <div className="m11c-homePts__header-icon">
                          <i className="m11ci-lightning"></i>
                        </div>
                        <div className="m11c-homePts__header-text">
                          <span>
                            <em>
                              5 <span>/ 5</span>
                            </em>
                            Booster Available
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m11c-contest__box">
                  <div className="m11c-booster__list">
                    <ul>{logoutData()}</ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    arrFixtures: state.appData.arrFixtures,
    objMix: state.appData.objMix,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBoostersCon: (payload) => dispatch(fetchBoostersCon(payload)),
    fetchGamerCard: (payload) => dispatch(fetchGamerCard(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(memo(UserBoosters));
